import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Batteries} from '../pages/layout/list-batteries/list-batteries.component';
import {Monthlyearnings} from '../pages/e-commerce/progress-section/progress-section.component';
import {Yearlyearnings} from '../pages/e-commerce/charts-panel/charts-panel.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TotalearningsService  {

  orgUrl = "";

  constructor(private afs: AngularFirestore) { }

  getMonthlyearnings() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.TotalEarningsDashboardCollection+'/Monthly').snapshotChanges().pipe(map(action => {
      const data = action.payload.data() as Monthlyearnings;
      const id = action.payload.id;
      return { id, ...data };
    }));
  }

  getPendingPayments() {
    return this.afs.doc('/UserWiseMonthlyData/UserData').snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      return data
    }));
  }

}
